import React, { memo } from 'react';
import { AlertCircle, ShoppingBag, Smartphone, Clock } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-159">
      <div className="max-w-3xl mx-auto" data-id="element-160">
        <div className="text-center mb-8" data-id="element-161">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5f] mb-3" data-id="element-162">
            Si eres mamá y estás en modo supervivencia...
          </h2>
          <p className="text-base text-slate-600" data-id="element-163">
            Conoces este diálogo interno de memoria:
          </p>
        </div>

        <div className="grid gap-4 mb-8" data-id="element-164">
          {[{
          text: '"Solo voy a comprar dos cositas."',
          icon: ShoppingBag
        }, {
          text: '"Solo voy a ypear esto rápido."',
          icon: Smartphone
        }, {
          text: '"Después veo cómo lo arreglo."',
          icon: Clock
        }].map((item, idx) => <div key={idx} className="flex items-center p-3 bg-slate-50 rounded-xl border-l-4 border-[#e63946]" data-id="element-165">
              <item.icon className="h-5 w-5 text-[#e63946] mr-3 flex-shrink-0" data-id="element-166" />
              <p className="text-lg font-medium text-slate-800 italic" data-id="element-167">
                {item.text}
              </p>
            </div>)}
        </div>

        <div className="bg-[#1e3a5f] text-white p-6 rounded-2xl shadow-xl" data-id="element-168">
          <p className="text-lg mb-4 leading-relaxed" data-id="element-169">
            Y cuando por fin llega la última semana del mes, te cae como una
            bolsa de cemento:{' '}
            <strong className="text-[#e63946] text-xl" data-id="element-170">NO HAY.</strong>
          </p>
          <ul className="space-y-2 mb-6 text-slate-200" data-id="element-171">
            <li className="flex items-center" data-id="element-172">
              <AlertCircle className="h-4 w-4 text-[#e63946] mr-2" data-id="element-173" />
              No hay para completar mercado.
            </li>
            <li className="flex items-center" data-id="element-174">
              <AlertCircle className="h-4 w-4 text-[#e63946] mr-2" data-id="element-175" />
              No hay para lo que pidió el colegio.
            </li>
            <li className="flex items-center" data-id="element-176">
              <AlertCircle className="h-4 w-4 text-[#e63946] mr-2" data-id="element-177" />
              No hay para un resfrío.
            </li>
          </ul>
          <p className="text-base font-medium border-t border-slate-600 pt-4" data-id="element-178">
            Y encima, tienes que actuar como si no pasara nada. Ese cansancio no
            es flojera.{' '}
            <span className="text-[#e63946] font-bold" data-id="element-179">
              Es vivir sin paredes.
            </span>
          </p>
        </div>
      </div>
    </section>;
}